import React, { useState } from 'react';
import UploadFile from './UploadFile';

const CacPage = () => {
	const [activeTab, setActiveTab] = useState('details');

	return (
		<>
			<div>
				<UploadFile activeTab={activeTab} setActiveTab={setActiveTab} />
			</div>
		</>
	);
};

export default CacPage;
